import { convertToDate } from '../rails_datetime_formatters.js'
import { extractDateFromRailsDateTime  } from '../rails_datetime_formatters.js'

const notAfterValidator = (date) => (value, _state) => {
  if (value && convertToDate(value) > convertToDate(date)) {
    return `Date can't be after ${extractDateFromRailsDateTime(date)}`
  }

  return null;
};

export default notAfterValidator;
